import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import * as userReducer from "./userSlice";
import * as applicationReducer from "./appSlice";
import * as uiReducer from "./uiSlice";
import * as customerReducer from "@/react/features/customer/customerSlice";
import * as vccssAgentsReducer from "@/react/features/vcc/agents/slice";
import * as destinationTypeReducer from "@/react/features/support-tools/extensions/forwarding-rules/destionationTypeSlice";

import { setupListeners } from "@reduxjs/toolkit/query";
import {
  customerBaseApi,
  emailBaseApi,
  dbServiceApi,
} from "@/react/services/api";
import { globalizationApi } from "@/react/features/globalization/globalizationApi";
import { jobsApi } from "@/react/features/jobs/jobsApi";
import { tenantInfoApi } from "@/react/features/vcc/tenant/tenantInfoApi";
import { supportedValuesApi } from "@/react/features/smp/supportedValuesApi";
import { encryptSecretsApi } from "@/react/features/support-tools/encryption";
import { csrApi } from "@/react/features/support-tools/csr";
import { addressValidationApi } from "@/react/features/support-tools/siptrunk/dids/addressValidationApi";
import { unbindVmmsApi } from "@/react/features/support-tools/unbind-vmms";
import { metadataApi } from "@/react/services/common/metadataApi";
import { xmlDialplansApi } from "@/react/features/support-tools/dialplans/xmlBasedApi";
import { globalDialplansApi } from "@/react/features/support-tools/dialplans/globalDialplansApi";
import jobInventoryApi from "@/react/features/job-inventory/api";

const reducers = combineReducers({
  [userReducer.name]: userReducer.default,
  [applicationReducer.name]: applicationReducer.default,
  [uiReducer.name]: uiReducer.default,
  [customerReducer.name]: customerReducer.default,
  [vccssAgentsReducer.name]: vccssAgentsReducer.default,
  [destinationTypeReducer.name]: destinationTypeReducer.default,
  [customerBaseApi.reducerPath]: customerBaseApi.reducer,
  [dbServiceApi.reducerPath]: dbServiceApi.reducer,
  [addressValidationApi.reducerPath]: addressValidationApi.reducer,
  [xmlDialplansApi.reducerPath]: xmlDialplansApi.reducer,
  [globalizationApi.reducerPath]: globalizationApi.reducer,
  [jobsApi.reducerPath]: jobsApi.reducer,
  [tenantInfoApi.reducerPath]: tenantInfoApi.reducer,
  [emailBaseApi.reducerPath]: emailBaseApi.reducer,
  [supportedValuesApi.reducerPath]: supportedValuesApi.reducer,
  [encryptSecretsApi.reducerPath]: encryptSecretsApi.reducer,
  [csrApi.reducerPath]: csrApi.reducer,
  [unbindVmmsApi.reducerPath]: unbindVmmsApi.reducer,
  [metadataApi.reducerPath]: metadataApi.reducer,
  [globalDialplansApi.reducerPath]: globalDialplansApi.reducer,
  [jobInventoryApi.reducerPath]: jobInventoryApi.reducer,
});

/**
 * For now, we are only interested in persisting the customer sub-state.
 */
const persistedReducer = persistReducer(
  {
    key: "root",
    storage,
    whitelist: ["customer"],
    debug: true,
  },
  reducers
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      customerBaseApi.middleware,
      dbServiceApi.middleware,
      addressValidationApi.middleware,
      globalizationApi.middleware,
      xmlDialplansApi.middleware,
      jobsApi.middleware,
      tenantInfoApi.middleware,
      emailBaseApi.middleware,
      supportedValuesApi.middleware,
      encryptSecretsApi.middleware,
      csrApi.middleware,
      unbindVmmsApi.middleware,
      metadataApi.middleware,
      globalDialplansApi.middleware,
      jobInventoryApi.middleware,
    ]),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
